var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-white",style:(`overflow-y: auto; overflow-x:hidden;max-height: ${_vm.defaultModalHeight}`)},[_c('div',[_c('div',[_c('p',[_vm._v(_vm._s(_vm.page.title))])]),_vm._v(" "),_c('div',{staticClass:"modal-module-page"},[_c('ckeditor',{attrs:{"value":_vm.page.content,"editor":_vm.editor},on:{"ready":_vm.onEditorReady}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }